import  ApiService  from '../../services/api.service'
import HashMake from '../../services/hash.service'

const state =  {
    productDetails: [],
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    isShow: false,
    loading: false
}

const getters = {
    productDetails: (state) => state.productDetails,
    loading: state => state.loading,
    isShow: (state) => state.isShow,
    response: (state) => state.response,
}

const actions = {
    showError({ commit }, value) {
        commit('setError', value)
    },
    resetError({ commit }) {
        commit('resetState')
    },
    async getProductDetails({ commit }, productId) {
        return await new Promise((resolve, reject) => {
            commit('setLoading', true)
            commit('setIsShow', true)

            ApiService.get('/product/'+productId+'/details?with=["images","brand","model","categories","inventories"]')
            .then(response => {
                
                commit('setProductDetails', response.data)
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    changeLoading({commit}, val) {
        commit('setLoading', val)
    },
    resetProductDetail({commit}, val) {
        commit('setProductDetails', val)
    }
}

const mutations = {
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setResponse(state, data) {
        state.response.message = data.message;
        if(data.success == true) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
    },
    setProductDetails(state, data) {
        state.productDetails = data;
    },
    setError(state, data) {
        state.isShow = true;
        state.response.variant = 'danger';
        state.response.message = data.msg;
        state.response.errmsg = data.errors;
    },
    resetState(state) {
        state.isShow = false;
        state.response.variant = '';
        state.response.message = '';
        state.response.errmsg = [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}